function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 6.5c1 0 1.3.2 2.2.8 1.4 1 2.2 1.2 3.8 1.2 1.6 0 2.5-.3 3.8-1.2 1-.6 1.3-.8 2.2-.8 1 0 1.3 0 2.2.7 1.3 1 2.2 1.3 3.8 1.3v-3c-1 0-1.3 0-2.2-.7-1.3-1-2.2-1.3-3.8-1.3-1.6 0-2.5.4-3.8 1.2-1 .7-1.3.8-2.2.8-1 0-1.2 0-2-.7-1.5-1-2.4-1.3-4-1.3v3zm0 6c1 0 1.3.2 2.2.8 1.4 1 2.2 1.2 3.8 1.2 1.6 0 2.5-.3 3.8-1.2 1-.6 1.3-.8 2.2-.8 1 0 1.3 0 2.2.7 1.3 1 2.2 1.3 3.8 1.3v-3c-1 0-1.3 0-2.2-.7-1.3-1-2.2-1.3-3.8-1.3-1.6 0-2.5.4-3.8 1.2-1 .7-1.3.8-2.2.8-1 0-1.2 0-2-.7-1.5-1-2.4-1.3-4-1.3v3zm0 6c1 0 1.3.2 2.2.8 1.4 1 2.2 1.2 3.8 1.2 1.6 0 2.5-.3 3.8-1.2 1-.6 1.3-.8 2.2-.8 1 0 1.3 0 2.2.7 1.3 1 2.2 1.3 3.8 1.3v-3c-1 0-1.3 0-2.2-.7-1.3-1-2.2-1.3-3.8-1.3-1.6 0-2.5.4-3.8 1.2-1 .7-1.3.8-2.2.8-1 0-1.2 0-2-.7-1.5-1-2.4-1.3-4-1.3v3z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationWater = function SvgLocationWater(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationWater;